import Vue from 'vue'
import Vuex from 'vuex'
import Constant from '@/const.js'

Vue.use(Vuex)

export default new Vuex.Store({

  /**
    * States
    */
    state: {
      env : {} ,
      // device
      device : {} , 
      // main theme
      theme : '' , 
      window : {} , 
      // main constant of project
      const: Constant , 
      // object containg all configurations of each dataviz (see main.js file or each json file in conf/)
      conf: {} , 
      // dictionnary, preload once to be used accross a website (see DatavizFilters or Database/Dictionnary page)
      dictionnary : {
        cancers : [] ,
        populations : [] , 
        populations_groupings : {
          'hdi' : [] , 
          'who' : [] , 
          'income' : [] , 
          'continents' : [] , 
          'regions' : [] , 
          'gicr_hubs' : []
        }
      },

      dc : {} ,

      current_scenario_keys : {},

      data : {} , 

      scale_up_target : {
        hpv: 90 , 
        screening : 70 , 
        treatment : 90
      },

      scale_up_target_code : '90-70-90' , 

      scenario : { value : 'init v' , label : 'init label'}, 

      components : []
    },

    /**
    * Mutations
    */
    mutations: {
      setEnv (state,env) {
          state.env = env
      },
      setConst (state,const_) {
          state.const = const_
      },
      setDevice (state,device) {
          state.device = device
      },
      setConf(state,conf){
        state.conf = conf 
      },
      setStaticData(state,conf){
        state.data = conf 
      },
      setDC(state,dc){
        state.dc = dc 
      },
      setCurrentScenarioKeys(state,current_scenario_keys){
        state.current_scenario_keys = current_scenario_keys 
      },
      setDictionnay(state,dictionnary){
        state.dictionnary = dictionnary ; 
        // console.log("$state.const",state.const.enable_population_grouping) ;
      },
      setFilters(state,filters){
        state.filters = filters 
      },
      setExtraTabs(state,extra_tabs){
        state.extra_tabs = extra_tabs 
      },
      setGraphic(state,graphic){
        state.graphic = graphic 
      },
      toggleRegionalFootnote(state,show){
        state.show_regional_footnote = show ; 
      },
      setGraphicFootnote(state,footenote){ 
        // let footnote_regional = ( state.filters.types == '0_1') ? "* Sub-national incidence data" : "* Sub-national data" ; 
        if ( state.graphic_footnotes.includes( footenote ) == false)
          state.graphic_footnotes.push( footenote ) ; 
      },
      clearGraphicFootnote(state){
        state.show_regional_footnote = false ; 
        state.graphic_footnotes = [] ; 
      },
      setScalUpTarget(state,v){
        state.scale_up_target = v.scale_up_target ;
        // console.log("store state",v.scale_up_target) ; 
        state.scale_up_target_code = `${v.scale_up_target.hpv}-${v.scale_up_target.screening}-${v.scale_up_target.treatment}` ;
      },
      setScenario(state,scenario){
        state.scenario = scenario ; 
      },
      addComponent(state,component){
        state.components.push(component) ; 
      },
      
    },
    
    /**
    * Actions
    */
    actions: {
    
    }
})
